import { Show, For, createSignal } from 'solid-js';
import { CheckboxFieldAttributes } from '../mautic-form-types';
import { formatLabel } from '../utils';

export const Checkbox = ({ fieldData }: { fieldData: CheckboxFieldAttributes }) => {
    const {
        alias,
        checkboxInputClasses,
        defaultValue,
        errors,
        id,
        isRequired,
        label,
        properties,
        showLabel,
        value,
        variant,
        handleChange,
        revalidate,
        errorInputClasses,
        errorId,
    } = fieldData;
    const error = () => Boolean(errors[alias]);
    const options = properties?.optionlist?.list ?? null;
    const initialValue = options && options.length === 1 ? (value ? !!value : false) : defaultValue ? [defaultValue] : [];
    const [chosen, setChosen] = createSignal<string[] | boolean>(initialValue);

    const stringID = String(id);

    const handleCheckboxChange = (value: string) => {
        let newValue = initialValue;

        if (options && options.length === 1) {
            newValue = !chosen();
            setChosen(newValue);
        }
        if (options && options.length > 1) {
            newValue = chosen();
            newValue = Array.isArray(newValue) ? (newValue.includes(value) ? newValue.filter((v) => v !== value) : [...newValue, value]) : [value];
            setChosen(newValue);
        }

        handleChange(alias, newValue);
    };

    const checkValue = (value: string) => {
        const chosenSignal = chosen();
        if (Array.isArray(chosenSignal) && chosenSignal.includes(value)) {
            return true;
        }
        if (chosenSignal === true) {
            return true;
        }
        return false;
    };

    return (
        <Show when={options && options.length > 0}>
            <fieldset id={stringID} {...(error() && { 'aria-describedby': errorId })}>
                <legend
                    classList={{
                        'sr-only': !showLabel,
                        'mb-xxs': showLabel,
                    }}
                >
                    {formatLabel(label, isRequired)}
                </legend>
                <For each={options}>
                    {(option) => (
                        <label
                            for={`check-${id}-${option.value}`}
                            class="relative flex"
                            classList={{
                                'mb-xxs': (options && options.length > 1) ?? false,
                            }}
                        >
                            <input
                                {...(error() && { 'aria-invalid': true })}
                                checked={checkValue(option.value)}
                                class={checkboxInputClasses}
                                classList={{
                                    'after:content-check': checkValue(option.value) && (variant === 'dark' || variant === 'outline-light'),
                                    'after:content-checkDark': checkValue(option.value) && (variant === 'outline-dark' || variant === 'light'),
                                    [errorInputClasses || '']: error(),
                                }}
                                type="checkbox"
                                name={alias}
                                id={`check-${id}-${option.value}`}
                                value={option.value}
                                onChange={(e) => {
                                    handleCheckboxChange(e.target.value);
                                    revalidate(alias, e.target.value, fieldData.validationMessage ?? '');
                                }}
                            />
                            <span class="text-paragraphS max-w-3xl pl-8">
                                {option.label}
                                {isRequired && options && options.length < 2 ? ' *' : ''}
                            </span>
                        </label>
                    )}
                </For>
            </fieldset>
        </Show>
    );
};
